<template>
  <div class="content">
    <div
      style="
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
      "
    >
      <label class="text-value">{{ component.label }}</label>
    </div>

    <div class="content-group-selection">
      <div
        v-for="option in component.options"
        :key="option.value"
        class="content-label-group"
        :class="{ 'is-selected': isSelected(option.value) }"
        @click="toggleField(option.value)"
      >
        <label class="text-value">{{ option.label }}</label>
      </div>

      <div
        v-for="field in component.fields"
        :key="field.name"
        class="content-label-group"
        :class="{ 'is-selected': isSelected(field.name) }"
        @click="toggleField(field.name)"
      >
        <label class="text-value">{{ field.label }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MultiSelectGroup',
  props: {
    component: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    selectedFields: [],
  }),
  methods: {
    isSelected(value) {
      return this.selectedFields.includes(value)
    },

    toggleField(value) {
      const index = this.selectedFields.indexOf(value)

      if (index > -1) {
        // Se já existe, remove (desmarca)
        this.selectedFields.splice(index, 1)
      } else {
        // Se não existe, adiciona (marca)
        this.selectedFields.push(value)
      }

      this.$emit('change', this.selectedFields)
    },
  },
}
</script>

<style scoped>
.content {
  display: flex;
  flex-direction: column;
  margin: 5px;
}
.content-label-group {
  display: flex;
  justify-content: center;
  padding: 20px;
  border-radius: 8px;
  background-color: #dddddd;
  cursor: pointer;
  transition: all 0.3s ease;
}
.content-label-group.is-selected {
  background-color: #0ba31f;
}
.is-selected .text-value {
  color: white !important;
}
.content-group-selection {
  display: flex;
  gap: 10px;
  flex-direction: column;
  background-color: white;
  padding: 10px;
  margin: 10px;
}
.text-value {
  font-size: 14px;
  font-family: 'Rajdhani', sans-serif;
  color: #69739e;
  padding-left: 10px;
  pointer-events: none;
}
</style>
